import { useTranslation } from 'react-i18next';
import { MESSAGE_TONE } from './messageTone';
import type { IBriefingListProps } from './IBriefingListProps';

/** «Що казати» (прототип v4 ivMsgs): тези за порядком — пігулка виду в його тоні, теза 600, доказ дрібним; ліва смуга в тоні виду. */
export function BriefingMessages({ items, labels, onOpen }: IBriefingListProps) {
  const { t } = useTranslation();
  const sorted = [...items].sort((a, b) => (Number(a.values['order']) || 0) - (Number(b.values['order']) || 0));
  return (
    <section className="viz-card">
      <div className="viz-card__title">{t('recordPage.viz.briefing.say')}</div>
      {sorted.map((r) => (
        <button key={r.id} type="button" className={`viz-item viz-item--msg viz-tone-${MESSAGE_TONE[String(r.values['mkind'])] ?? 'neutral'}`} onClick={() => onOpen(r)}>
          {r.values['mkind'] ? <span className="viz-item__kind">{labels.option('mkind', r.values['mkind'])}</span> : null}
          <strong>{r.title || r.display}</strong>
          {r.values['evidence'] ? <span className="viz-item__meta">{String(r.values['evidence'])}</span> : null}
        </button>
      ))}
    </section>
  );
}
